import Button from '../../../button';
import Image from 'next/image';

interface IPremiumAccessOverlayProps {
  link?: string;
}

export const PremiumAccessOverlay = ({
  link = '',
}: IPremiumAccessOverlayProps) => {
  return (
    <div className="absolute top-0 left-0 right-0 bottom-0 bg-white/50 flex flex-col justify-center items-center">
      {/* <RiVipCrownFill color="#dbbf1d" size={32} />; */}
      <div className="h-12 w-12 bg-[#0A1B23] mb-2 flex justify-center items-center rounded-full">
        <Image src="/images/prime-icon.svg" alt="" height={32} width={32} />
      </div>
      <p className="text-2xl font-bold mb-2">Recurso exclusivo Retorno Prime</p>
      <p className="text-sm mb-3">
        Faça o upgrade e aproveite esta e outras vantagens.
      </p>
      <Button
        target="_blank"
        href={link}
        rel="noopener"
        variant="contained"
        color="secondary"
        className="text-transform-none"
      >
        Conheça o Retorno Prime
      </Button>
    </div>
  );
};
